import { render, staticRenderFns } from "./ReplaceMetro.vue?vue&type=template&id=620545ed"
import script from "./ReplaceMetro.vue?vue&type=script&lang=js"
export * from "./ReplaceMetro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports